<template>
  <teleport to="#modalTeleport">
    <ConfirmModal ref="confirmModal"></ConfirmModal>
  </teleport>
  <HeadlineComponent :subtitle="`Insgesamt ${apikeys.length}`">API Keys</HeadlineComponent>
  <template v-for="apikey of apikeys" :key="apikey.id">
    <div class="guest mb-4">
      <div>
        <span>{{ apikey.name }}</span>
      </div>
      <div class="system-info">
        <LoadingButton @click="remove(apikey);" class="btn-danger btn-sm mt-2" :loading="apikey.loading">Löschen <span
            class="fa fa-remove"></span></LoadingButton>
      </div>
    </div>
    <hr class="mb-4 volunteer-hr" />
  </template>

  <h2>Neuen Key anlegen</h2>
  <Form class="form-horizontal" @submit="create">
    <div class="form-group">
      <BootstrapField type="text" placeholder="Name" name="name" rules="required" />
    </div>
    <div class="form-group">
      <LoadingButton class="btn-primary" :loading="loading">Hinzufügen</LoadingButton>
    </div>
  </Form>
</template>

<script>
import { mapActions } from "pinia";
import { useAlertsStore } from "@/stores/alerts.js";
import apikeyService from "@/services/apikey.service.js";
import LoadingButton from "@/components/LoadingButton.vue";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import ConfirmModal from "@/components/ConfirmModal.vue";
import { Form } from 'vee-validate';
import BootstrapField from "@/components/BootstrapField.vue";
import { setErrors } from '@/helper/ErrorToActions.js';
import * as Sentry from '@sentry/vue';

export default {
  name: "IndexView",
  components: { LoadingButton, HeadlineComponent, ConfirmModal, BootstrapField, Form },
  data() {
    return {
      apikeys: [],
      name: "",
      loading: false
    }
  },
  async beforeMount() {
    try {
      let response = await apikeyService.index();
      this.apikeys = response.data;
    } catch (e) {
      if (e) {
        Sentry.captureException(e);
        this.addAlert('danger', "Es ist was unerwartetes schief gegangen..");
        window.scrollTo(0, 0);
      }
    }
  },
  methods: {
    ...mapActions(useAlertsStore, { addAlert: 'add' }),
    async create(form, actions) {
      this.loading = true;
      try {
        let response = await apikeyService.create({ name: form.name });
        this.apikeys.push(response.data)
        this.addAlert('success', 'Apikey erfolgreich hinzugefügt. Merk dir "' + response.data.token + '" gut, es ist das einzige mal, das der Token angezeigt wird!', false)
        this.loading = false;
        actions.resetForm();
      } catch (e) {
        if (e) {
          if (e.response.data && e.response.data.errors) {
            setErrors(e.response.data.errors, actions)
            this.loading = false;
            return
          }
          Sentry.captureException(e);
          this.addAlert('danger', "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
        this.loading = false;
      }
    },
    async remove(apikey) {
      apikey.loading = true;
      if (await this.$refs.confirmModal.show('API key löschen', `Soll der API key ${apikey.name} wirklich gelöscht werden?`)) {
        try {
          await apikeyService.remove(apikey.id);
          for (let i = 0; i < this.apikeys.length; i++) {
            if (this.apikeys[i].id === apikey.id) {
              this.apikeys.splice(i, 1);
              break;
            }
          }
        } catch (e) {
          if (e) {
            Sentry.captureException(e);
            this.addAlert('danger', "Es ist was unerwartetes schief gegangen..");
            window.scrollTo(0, 0);
          }
        }
      }
      apikey.loading = false;

    }
  }
}
</script>

<style scoped></style>